module.exports = __webpack_public_path__ + "static/img/image024.4489847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image024.png
// module id = PQ+r
// module chunks = 1